import { ColumnDescriptorProps, ListTable } from '../../../../../components/table/ListTable';
import { FieldOrNoData } from '../../../../../components/PropertyTableFieldDefinitions';
import { useAppSelector } from '../../../../../configuration/setup/hooks';
import { getSelectedDeviceStateSidebar } from '../sidebarSlice';
import React from 'react';
import { useFetchCidSummaryQuery } from '../../../../../services/connectedVehiclesApi';

export interface CidSummary {
    originator: string,
    cid: number,
    messagesNumber: number,
    platformEntryUtc: number,
    referenceTimeUtc: number,
    avgDelay: number,
    avgMessageSize: number
}

const columnDescriptors: ColumnDescriptorProps<CidSummary>[] = [
    {
        id: 'cid',
        field: 'cid',
        label: 'CID',
        format: (field: string) => <FieldOrNoData field={field} />,
    },
    {
        id: 'messagesNumber',
        field: 'messagesNumber',
        label: '# Messages',
        format: (_, item?: CidSummary) => <FieldOrNoData field={item!.messagesNumber.toLocaleString()} />,
    },
    {
        id: 'platformEntryUtc',
        field: 'platformEntryUtc',
        label: 'Platform Entry UTC',
        format: (_, item?: CidSummary) => <FieldOrNoData field={
            <span>{new Date(item!.platformEntryUtc * 1000).toISOString()}</span>
        } />,
    },
    {
        id: 'referenceTimeUtc',
        field: 'referenceTimeUtc',
        label: 'Reference Time UTC',
        format: (_, item?: CidSummary) => <FieldOrNoData field={
            <span>{new Date(item!.referenceTimeUtc * 1000).toISOString()}</span>
        } />,
    },
    {
        id: 'avgDelay',
        field: 'avgDelay',
        label: 'Average Delay',
        format: (_, item?: CidSummary) => <FieldOrNoData field={
            <span>{item!.avgDelay}&nbsp;ms</span>
        } />,
    },
    {
        id: 'avgMessageSize',
        field: 'avgMessageSize',
        label: 'Average Message Size',
        format: (_, item?: CidSummary) => <FieldOrNoData field={
            <span>{item!.avgMessageSize}&nbsp;bytes</span>
        } />,
    },
];

const dummyData: CidSummary[] = [
    {
        originator: 'cm4:12345-1234',
        cid: 101,
        messagesNumber: 12632,
        platformEntryUtc: 1759762481,
        referenceTimeUtc: 1759762475,
        avgDelay: 5,
        avgMessageSize: 255,
    },
];

export const CidSummaryContainer = () => {
    const selectedDevice = useAppSelector(getSelectedDeviceStateSidebar);
    const originator = selectedDevice?.originator;
    const { data, isLoading, error } = useFetchCidSummaryQuery({ originator });

    return (
        <>
            {
                !!data &&
                <ListTable<CidSummary>
                    showHeader
                    items={data}
                    itemKey="cid"
                    columnDescriptors={columnDescriptors}
                    className={'justify-content-end'} />
            }
        </>
    );
};
